<template>
  <!-- Healing Help Card -->
  <div>
    <h3>{{$t('Webportal.CX.Margin.MarginHealingHelpTitle')}}</h3>

    <p  v-for="(item) in helpTexts" 
        :key="item"
        v-html="$t('Webportal.CX.Margin.MarginHealingHelpText' + item)" />
    
    <b>{{ $t('Webportal.CX.Margin.FAQHealingPeriodHealine') }}</b>

    <ul>
      <li v-for="(item) in helpTexts" :key="item">{{ $t('Webportal.CX.Margin.Q' + item + 'HealingTime') }}</li>
    </ul>
  </div>
</template>

<script>

export default {
  data() {
    return {
      quarters: [ 1, 2, 3, 4],
      helpTexts: [ 1, 2, 3, 4, 5],
    }
  }
}

</script>
